import getStore from "store";

import { getUserYearGroup } from "seneca-common/features/user/state";

import { getFeatureFlag } from "features/feature-flags";

import { isPrimaryApp as isPrimaryAppLogic } from "./logic";

export function isPrimaryApp() {
  const state = getStore().getState();
  const yearGroup = getUserYearGroup(state);

  return isPrimaryAppLogic({
    yearGroup,
    featureFlagEnabled: !!getFeatureFlag("isPrimaryApp")
  });
}
